import { Injectable } from '@angular/core';
import { AsyncValidator, AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors} from '@angular/forms';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService} from "../api.service";
import { Angulartics2 } from 'angulartics2';

@Injectable()
export class EmailPreregisteredValidator implements AsyncValidator {
    constructor(private apiService: ApiService, private angulartics2: Angulartics2) {}

    validate = (ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null>  => {
        this.angulartics2.eventTrack.next({ action: 'preReg_emailSubscribed_send', properties: { category: 'preregistration' }});
        return this.apiService.isEmailSubscribed(ctrl.value).pipe(
            map( (response) => {
                if (response) {
                    this.angulartics2.eventTrack.next({action: 'preReg_emailSubscribed_failed', properties: {category: 'preregistration'}});
                    return {emailAlreadyRegistered: true};
                } else {
                    this.angulartics2.eventTrack.next({action: 'preReg_emailSubscribed_success', properties: {category: 'preregistration'}});
                    return null;
                }
            }
            )
        );
    }
}